import React, { useState } from 'react';
import TextField from '@material-ui/core/TextField';

import Button from '@material-ui/core/Button';
import Dialog, { DialogProps } from '@material-ui/core/Dialog';
import MuiDialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogContentText from '@material-ui/core/DialogContentText';
import MuiDialogTitle from '@material-ui/core/DialogTitle';
import { makeStyles, withStyles } from '@material-ui/core/styles';

const DialogTitle = withStyles((theme) => ({
  root: {
    paddingTop: theme.spacing(3),
    paddingBottom: theme.spacing(),
  },
}))(MuiDialogTitle);

const DialogActions = withStyles((theme) => ({
  root: {
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'center',
    paddingLeft: theme.spacing(),
    paddingRight: theme.spacing(),
    paddingBottom: theme.spacing(),
  },
}))(MuiDialogActions);

const useStyles = makeStyles((theme) => ({
  content: {
    width: 325,
    padding: theme.spacing(),
  },
}));

type Props = Pick<DialogProps, 'open' | 'onClose'> & {
  confirmButtonText?: string;
  cancelButtonText?: string;
  title: string;
  onConfirm: (email: string) => void;
  onCancel?: () => void;
  contentText: string;
};

export default function AlertExistingMemberEmailDialog({
  cancelButtonText,
  confirmButtonText,
  onClose,
  onCancel,
  onConfirm,
  open,
  title,
  contentText,
}: Props) {
  const classes = useStyles();
  const [email, setEmail] = useState('');
  const [helperText, setHelperText] = useState('');

  const handleSubmit = () => {
    if (email.length === 0) {
      setHelperText('Required');
    } else {
      onConfirm(email);
    }
  };

  return (
    <Dialog open={open} onClose={onClose}>
      <div className={classes.content}>
        <DialogTitle>{title}</DialogTitle>
        <DialogContent>
          <DialogContentText>{contentText}</DialogContentText>
          <TextField
            label={''}
            value={email}
            onChange={(e) => {
              setEmail(e.target.value);
              setHelperText('');
            }}
            error={helperText.length > 0}
            helperText={helperText}
            fullWidth
          />
        </DialogContent>
        <DialogActions>
          <Button
            onClick={handleSubmit}
            color="primary"
            autoFocus
            disabled={email.length === 0}
          >
            {confirmButtonText || 'Confirm'}
          </Button>
          {cancelButtonText && onCancel && (
            <Button onClick={onCancel} variant="contained" autoFocus>
              {cancelButtonText}
            </Button>
          )}
        </DialogActions>
      </div>
    </Dialog>
  );
}
